import { useCallback } from "react";
import { LessonListenCounts } from "../utils/lessonListenCountsStorage";
import { useDeviceProgress } from "./useDeviceProgress";

export function useLessonListenCounts() {
    const { data: counts, update, syncStatus } = useDeviceProgress<LessonListenCounts>("lessonListenCounts", true);
    const increment = useCallback((key: string) => { void update({ kind: "increment", key }); }, [update]);
    return { counts, increment, syncStatus };
}
